const actions = {
  FETCH_CMS_BODY_CLASS_NAME: "fetchCmsBodyClassName",
  FETCH_CMS_PAGE: "fetchCmsPage",
  FETCH_CMS_MENU: "fetchCmsMenu"
};

export default actions;
